import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import { DataExportList } from './components/DataExportList'

const dataExportBreadcrumbs: Array<PageLink> = [
  {
    title: 'Data Export',
    path: '/data_export/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DataExportPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Data Export'}></DocumentTitle>
              <PageTitle breadcrumbs={dataExportBreadcrumbs}>Export</PageTitle>
              <DataExportList />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default DataExportPage
